import React from "react";
import "./styles.scss";
import _ from "lodash";
import FullPageSpinner from "./../../../../components/FullPageSpinner";
import { indexWhatsHot } from "../../../../api/discover";
import { Link } from "react-router-dom";
import defaultAlbumImg from "../../../../public/images/default-alblum-img.png";
import staticTrendImage from "../../../../public/static_trends_image.png";

class Trends extends React.PureComponent {
  state = { trending: null };
  componentDidMount = () => {
    this.fetchData();
  };
  fetchData = async () => {
    try {
      let { data } = await indexWhatsHot({ size: 6 });
      this.setState({ trending: data.new });
    } catch (error) {}
  };

  getTopMargin = (min, max) => {
    return (Math.floor(Math.random() * (max - min + 1)) + min) * 10;
  };
  textRenderer = (text, duration, direction, object) => {
    return (
      <Link
        to={this.renderDataUrl(object)}
        className="trend-link position-absolute bg-yellow p-2"
        style={{
          textDecoration: "none",
          maxWidth: "70%",
          top: `${this.getTopMargin(duration[0], duration[1])}%`,
          ...(direction === "left" ? { left: 0 } : { right: 0 }),
        }}
      >
        <h4 className="text-black font-weight-bolder m-0 text-capitalize">{text}</h4>
      </Link>
    );
  };

  renderLabels = (trendItem) => {
    return (
      <>
        {trendItem.title && this.textRenderer(trendItem.title, [3, 3], "left", trendItem)}
        {trendItem.sub_title && this.textRenderer(trendItem.sub_title, [6, 6], "left", trendItem)}
        {trendItem.rank && trendItem.rank_in && this.textRenderer(`#${trendItem.rank} in ${trendItem.rank_in}`, [8, 8], "right", trendItem)}
      </>
    );
  };

  trendRenderer = (trendItem, clasname = "") => {
    if (!trendItem) return;
    const children = (
      <>
        {this.renderLabels(trendItem)}
        {this.getThumbnail(trendItem)}{" "}
      </>
    );
    return (
      <>
        {trendItem.type == "Video" ? (
          <div className={`trend-item position-relative ${clasname}`}>{children}</div>
        ) : (
          <Link className={`trend-item position-relative ${clasname}`} to={this.renderDataUrl(trendItem)}>
            {children}
          </Link>
        )}
      </>
    );
  };

  getThumbnail = (trend) => {
    switch (trend.type) {
      case "Video":
        return <video controls src={trend.video.url} />;
      case "SoundTrack":
        return <img src={(trend.sound_track.preview_image && trend.sound_track.preview_image.url) || defaultAlbumImg} />;
      case "User":
        return (
          <img src={(trend.user.profile_picture && trend.user.profile_picture.url) || require("../../../../public/shared/avatar-default.svg")} />
        );
    }
  };

  renderDataUrl = (trend) => {
    if (trend.navigate_to_type == "Post") return `/post/${trend.navigate_to_id}`;

    if (trend.navigate_to_type == "Album" || trend.navigate_to_type == "Playlist") {
      if (trend.type == "Video") {
        return `/${trend.video.user.slug}/${trend.navigate_to_type}s/${trend.navigate_to_id}`;
      } else if (trend.type == "SoundTrack") {
        return `/${trend.sound_track.user.slug}/${trend.navigate_to_type}s/${trend.navigate_to_id}`;
      }
    }

    if (trend.navigate_to_type == "User") {
      if (trend.type == "Video") {
        return `/${trend.video.user.slug}`;
      } else if (trend.type == "SoundTrack") {
        return `/${trend.sound_track.user.slug}`;
      } else {
        return `/${trend.user.slug}`;
      }
    }
  };

  render() {
    return this.state.trending === null ? (
      <FullPageSpinner />
    ) : (
      <div id="trends" className="d-flex flex-column h-100 overflow-hidden">
        <h1 className="m-4">The Latest on UNIFI Music</h1>
        <div className="row no-gutters overflow-hidden" style={{ flex: 1.5 }}>
          {this.trendRenderer(this.state.trending[0], "col-60 h-100")}
          <div className="col-40 h-100 d-flex flex-column">
            <img alt="" className="img-fluid" src={staticTrendImage} />
            {this.trendRenderer(this.state.trending[1], "flex-grow-1")}
          </div>
        </div>
        <div className="row no-gutters overflow-hidden" style={{ flex: 1 }}>
          {this.trendRenderer(this.state.trending[2], "col-33 h-100")}
          {this.trendRenderer(this.state.trending[3], "col-34 h-100")}
          {this.trendRenderer(this.state.trending[4], "col-33 h-100")}
        </div>
      </div>
    );
  }
}

export default Trends;
